import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export default function FormDialog({
  open,
  title,
  children,
  onClose,
  onSubmit,
  submitLabel = 'Salvar',
  cancelLabel = 'Cancelar',
  submitting = false,
  maxWidth = 'sm',
}) {
  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth={maxWidth} scroll="paper" aria-labelledby="form-dialog-title" PaperProps={{ sx: { overflowX: 'hidden', maxWidth: '100%' } }}>
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important', overflowX: 'hidden', minWidth: 0, '& > *': { minWidth: 0, maxWidth: '100%' } }}>
        {children}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={submitting}>
          {cancelLabel}
        </Button>
        <Button variant="contained" onClick={onSubmit} disabled={submitting}>
          {submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
